/**
 * Lightweight, non-blocking heuristic for whether a visitor is likely
 * browsing from Europe. Used only to decide whether to show a soft notice
 * about current coverage — never to block access or hide functionality.
 */

// IANA zones outside "Europe/*" that are still effectively covered by our
// current Mon–Sat 07:00–23:00 CET window (close enough in offset/culture).
const EXTRA_EUROPEAN_ZONES = new Set([
  "Africa/Casablanca",
  "Africa/Algiers",
  "Africa/Tunis",
  "Atlantic/Canary",
  "Atlantic/Madeira",
  "Atlantic/Reykjavik",
]);

export const detectVisitorTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch (err) {
    return "";
  }
};

/**
 * Returns true when we're reasonably confident the visitor is in Europe,
 * false when we're reasonably confident they are not, and null when the
 * timezone is missing/ambiguous (e.g. "UTC") — in the null case we should
 * not show anything, to avoid false positives.
 */
export const isLikelyEuropeanTimezone = (timezone = detectVisitorTimezone()) => {
  if (!timezone) return null;
  if (timezone.startsWith("Europe/")) return true;
  if (EXTRA_EUROPEAN_ZONES.has(timezone)) return true;
  if (timezone === "UTC" || timezone === "GMT" || timezone === "Etc/UTC") {
    return null; // ambiguous — could be Europe, could be anywhere
  }
  return false;
};
